var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header my-6"},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticClass:"justify-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }